import { Component, Input } from '@angular/core';
import { TraitementDataFrequenceComponent } from '../../traitement-data/traitement-data-frequence/traitement-data-frequence.component';
import { Patient } from '../../../models/patient';
import { TraitementDataObsComponent } from "../../traitement-data/traitement-data-obs/traitement-data-obs.component";
import { TraitementDataIahrComponent } from "../../traitement-data/traitement-data-iahr/traitement-data-iahr.component";
import { TraitementDataEpapIpapComponent } from "../../traitement-data/traitement-data-epap-ipap/traitement-data-epap-ipap.component";
import { TraitementDataVolumeCourantMediane95Component } from "../../traitement-data/traitement-data-volume-courant-mediane-95/traitement-data-volume-courant-mediane-95.component";
import { TraitementDataFrequenceRespiratoireMediane95Component } from "../../traitement-data/traitement-data-frequence-respiratoire-mediane-95/traitement-data-frequence-respiratoire-mediane-95.component";
import { TraitementDataFuitesMediane95Component } from "../../traitement-data/traitement-data-fuites-mediane-95/traitement-data-fuites-mediane-95.component";
import { TraitementDataModeComponent } from '../../traitement-data/traitement-data-mode/traitement-data-mode.component';
import { TraitementDataComponent } from "../../traitement-data/traitement-data/traitement-data.component";
import { TraitementDataDureeComponent } from '../../traitement-data/traitement-data-duree/traitement-data-duree.component';
import { TraitementDataO2EffortComponent } from '../../traitement-data/traitement-data-o2-effort/traitement-data-o2-effort.component';
import { TraitementDataO2ReposComponent } from '../../traitement-data/traitement-data-o2-repos/traitement-data-o2-repos.component';

@Component({
  selector: 'app-traitement-vni-card',
  standalone: true,
  imports: [
    TraitementDataModeComponent,
    TraitementDataFrequenceComponent,
    TraitementDataObsComponent,
    TraitementDataIahrComponent,
    TraitementDataEpapIpapComponent,
    TraitementDataVolumeCourantMediane95Component,
    TraitementDataFrequenceRespiratoireMediane95Component,
    TraitementDataFuitesMediane95Component,
    TraitementDataComponent,
    TraitementDataO2EffortComponent,
    TraitementDataO2ReposComponent,
    TraitementDataDureeComponent,
  ],
  templateUrl: './traitement-vni-card.component.html',
  styleUrl: './traitement-vni-card.component.scss',
})
export class TraitementVniCardComponent {
  @Input() patient: Patient | undefined;
  @Input() activite: String | undefined;
}
